import React from "react";
import { StyleSheet, View, FlatList } from "react-native";
import color from "@constants/color";
import {
  BasePayoutCard,
  WeightPayoutCard,
  SurgePayoutCard,
  AttendanceIncentiveCard,
  DeliveryIncentiveCard,
  ResultCard,
} from "./PayoutCards";

interface PayoutData {
  cxCount: number;
  incentive: number;
  total: number;
  category?: string;
  slab?: string;
  date?: string;
}

interface TabularResultSubCardProps {
  extra_info?: {
    [key: string]: {
      title: string;
      should_show: boolean;
      data: PayoutData[];
      key: string;
    };
  };
  result?: {
    title: string;
    subtitle?: string;
    value: string;
  };
  setModalType?: (type: string) => void;
  selectedTab: string;
}

const TabularResultSubCard: React.FC<TabularResultSubCardProps> = ({
  extra_info = {},
  result = {},
  setModalType = () => {},
  selectedTab,
}) => {
  const renderCard = ({ item }: { item: { key: string; info: any } }) => {
    if (!item.info.should_show) return null;

    switch (item.key) {
      case "BASE_PAYOUT":
        return <BasePayoutCard title={item.info.title} data={item.info.data} />;
      case "WEIGHT_PAYOUT":
        return (
          <WeightPayoutCard title={item.info.title} data={item.info.data} />
        );
      case "SURGE_PAYOUT":
        return (
          <SurgePayoutCard
            title={item.info.title}
            data={item.info.data}
            selectedTab={selectedTab}
          />
        );
      case "ATTENDANCE_INCENTIVE":
        return (
          <AttendanceIncentiveCard
            title={item.info.title}
            data={item.info.data}
            setModalType={setModalType}
            cta_api={item.info.cta_api}
            cta_txt={item.info.cta_txt}
          />
        );
      case "DELIVERY_INCENTIVE":
        return (
          <DeliveryIncentiveCard
            title={item.info.title}
            data={item.info.data}
            setModalType={setModalType}
            cta_api={item.info.cta_api}
            cta_txt={item.info.cta_txt}
          />
        );
      default:
        return null;
    }
  };

  const cards = Object.entries(extra_info).map(([key, info]) => ({
    key,
    info,
  }));

  return (
    <View style={styles.container}>
      <FlatList
        data={cards}
        renderItem={renderCard}
        keyExtractor={(item) => item.key}
        ListFooterComponent={
          <ResultCard
            title={result.title || ""}
            value={result.value || ""}
            subtitle={result.subtitle || ""}
          />
        }
        contentContainerStyle={styles.listContent}
      />
    </View>
  );
};

export default TabularResultSubCard;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: color.white,
  },
  listContent: {
    padding: 16,
  },
});
